// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { compactHeaderStyles } from "@ces/Overrides/Pages/CompactHeader";
import { color, layoutContainer, xScreen } from "@ces/XDL/Utilities";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

compactHeaderStyles.page = {
    padding: 0, // * Padding doesn't work with fullWidth because of logic on Line 64 if Page component
    fullWidth: [true, true, true, true, true], // make the header full width and control the margins with container css
    css: css`
        top: 0;
        left: 0;
        z-index: ${getProp("theme.zIndex.compactHeader")};
        opacity: 0;
        transform: translateY(-100%) translateX(0);
        padding: ${props => props.theme.header.padding};
        background-color: ${getColor("common.white")};
        &&&& {
            position: fixed;
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
        box-shadow: ${({ showMainNavigation }: any) =>
            !showMainNavigation
                ? css`
                    0 1px 0 0 ${getColor("common.ui3")}
                  `
                : "none"};
    `,
};

compactHeaderStyles.logoWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 32px;
    `,
};

compactHeaderStyles.actionsWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex: 0 0 200px;
    `,
};

compactHeaderStyles.navigationWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        position: absolute;
        background: ${color("common.white")};
        width: 100%;
        top: -200px;
        box-shadow: 0 1px 0 0 ${color("common.ui11")};
        padding: 8px 0 12px 0;
        ${({ showMainNavigation }: any) =>
            showMainNavigation
                ? css`
                      top: 100%;
                      transform: translateY(-1px); // To replace box-shadow
                  `
                : ""}
        > div {
            ${layoutContainer}
        }
        &&&& > main {
            margin-bottom: 0;
        }
    `,
};

compactHeaderStyles.headerLinkListWrapper = {
    css: css`
        display: flex;
        &&&& {
            padding: 0;
        }
        .list-wrapper {
            display: flex;
            flex-wrap: nowrap;
        }
    `,
};

compactHeaderStyles.itemsWrapper = {
    css: css`
        flex-grow: 1;
    `,
};
compactHeaderStyles.rightSectionWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 32px;
    `,
};
compactHeaderStyles.mainNavigationPageWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};
compactHeaderStyles.mainNavigationWrapper = {
    css: css`
        &&&& {
            padding: 0;
        }
    `,
};
compactHeaderStyles.closeMenuClickable = {
    css: css`
        width: 30px;
        height: 30px;
        justify-content: center;
        &:hover {
            ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        }
    `,
};

compactHeaderStyles.searchWrapper = {
    css: css`
        align-self: center;
        flex-grow: 1;
    `,
};

compactHeaderStyles.spotStyle = {
    css: css`
        flex-grow: 1;
        ${TypographyStyle} {
            &,
            > span {
                margin-bottom: 0;
                font-size: 12px;
                line-height: 13px;
                color: ${color("common.black")} !important;
                text-align: right;
            }
        }
        ${ContentWrapper} {
            display: flex;
            align-items: center;
        }
        margin-left: auto;
    `,
};
